module.exports = __webpack_public_path__ + "images/help/cloud-big@2x-ed83fb3a2da6b383b1673a10ed5265bb.png";